import { createApp } from 'vue';
import './style.css';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import { MotionPlugin } from '@vueuse/motion';
import 'element-plus/dist/index.css';
import permission from './utils/permission';

// import * as ElementPlusIconsVue from '@element-plus/icons-vue'
// import {
//   VxeUI,

//   // VxeButton,
//   // VxeButtonGroup,
//   // VxeDrawer,
//   // VxeForm,
//   // VxeFormGroup,
//   // VxeFormItem,
//   // VxeIcon,
//   // VxeLoading,
//   // VxeModal,
//   // VxePager,
//   // VxeTooltip,
// } from 'vxe-pc-ui'

// import {
//   VxeTable,
//   VxeColumn,
//   // VxeColgroup,
//   // VxeGrid,
//   VxeToolbar
// } from 'vxe-table'
// 导入主题变量，也可以重写主题变量
// import 'vxe-table/styles/cssvar.scss'
// import 'vxe-pc-ui/styles/cssvar.scss'
// 导入默认的语言
// import zhCN from 'vxe-table/locale/lang/zh-CN'

// VxeUI.setI18n('zh-CN', zhCN)
// VxeUI.setLanguage('zh-CN')

const pinia = createPinia();
const app = createApp(App);
app.directive('permission', permission);
// 导入所有图标并全局注册
// for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
//   app.component(key, component)
// }

// 全局注册对象
// console.log(app.config.globalProperties)

app.use(pinia).use(router).use(MotionPlugin).mount('#app');
